<template>
  <!--h1>Files</h1>-->
  <!--div class="debug">
        <p> src url for iframe = {{ url }}</p>
        <p> project is == {{ project }}</p>
        <p> folderId is {{ folderId }} </p>
    </div>-->
  <!--TEST EMBEDING GOOGLE DRIVE FOLDER IN IFRAME-->
  <!--iframe src="https://drive.google.com/a/smpwork.com/embeddedfolderview?id=1biukk8-7iaS53pSq2uCJ1qUDFWjxNm-x#grid" style="width:100%; height:600px; border:0;"></iframe>-->
  <div v-if="folderId">
    <fieldset>
      <legend>Files</legend>
      <span>
        <label>Google Drive Link: </label>
        <a :href="folderLink" target="_blank">{{ folderLink }}</a>
      </span>
      <iframe :src="url" style="width: 100%; height: 600px; border: 0"></iframe>
    </fieldset>
  </div>
  <div v-else>
    <p>Project folder does not appear to exist on Google Drive</p>
    <button type="button" @click="createProjectFolder">Create Project Folder</button>
  </div>
  <div class="btn-row-left" v-if="folderId">
    <FormBtn :name="'Create Postech Calc'" @clicked="createPostechCalc"></FormBtn>
    <FormBtn :name="'Create Beam Calc'" @clicked="createBeamCalc"></FormBtn>
    <FormBtn :name="'Create Checksheet'" @clicked="createChecksheet"></FormBtn>
    <FormBtn :name="'Create Empty Letter'" @clicked="createGenericLetter"></FormBtn>
  </div>
  <div class="btn-row-left" v-if="displayPdfButtons">
    <Form-input v-model="municipality" :name="'Municipality:'"></Form-input><FormBtn :name="'Download SchB for Screw Piles'" @clicked="downloadSchB"></FormBtn>
  </div>
  <div class="debug">
        <p>folderId = {{ currentProject.folderId }}</p>
        <p>url = {{ url }}</p>
        <p>folderLink = {{ folderLink }}</p>
        <p>currentGroup = {{ userStore.currentGroup}}</p>
        <p>displayPdfButtons = {{ displayPdfButtons }}</p>
    </div>
</template>

<script setup lang="ts">
import { useProjectStore, useFileStore, useAlertStore, useUserStore } from '@/stores/'
import { getCofA } from '@/composables/Closeout-builder'
import { ref, computed } from 'vue'
//import router from '@/router'
import { FormBtn, FormInput } from '@/components/form'
//import ProjectInvoices from '../invoices/Project-invoices.vue'
//import { projectInfoSchema } from '@/types/types'
import { formatDate } from '@/libs/utils'
import { useCurrentProject } from '@/composables/Current-project'
import { usePdfDownloader, type schBForm } from '@/composables/pdf-downloader'


const displayPdfButtons = computed(()=>{
  console.log("computing displayPdfButtons : "+ currentProject.value.province + " : " + userStore.currentGroup);
  if (currentProject.value.province === 'BC' && userStore.currentGroup === 'admin'){
    return true
  }else{
    return false
  }
});

const userStore = useUserStore();
const projects = useProjectStore()
const props = defineProps({
  projectId: { type: Number, required: true }
  //folderId: {type: String, required : true}
})
//const project = await projects.getById(props.projectId);
const { currentProject } = useCurrentProject(); 
//const project = await projects.currentProject
//const projectInfo = await ref<ProjectInfo>(project.projectInfo)
//const folderId = ref('1biukk8-7iaS53pSq2uCJ1qUDFWjxNm-x');
const folderId = await ref(currentProject.value.folderId)
const municipality = ref();

const url = computed(() => {
  return `https://drive.google.com/a/smpwork.com/embeddedfolderview?id=${folderId.value}#grid`
})

const folderLink = computed(() => {
  return `https://drive.google.com/drive/folders/${folderId.value}`
})


async function createProjectFolder() {
  console.log('createprojectfolder clicked...')
  await projects.createFolder(currentProject.value)
}

async function createPostechCalc() {
  console.log('project files.createPostechCalc()')
  const fileStore = useFileStore()
  await fileStore.createPostechCalc(currentProject.value)
}

async function createChecksheet() {
  console.log('project files.createChecksheet()')

  const checker = userStore.currentEmail
  const payload = currentProject.value
  payload.checker = checker
  const fileStore = useFileStore()
  await fileStore.createChecksheet(payload)
}

async function createGenericLetter() {
  console.log('project files.createGenericLetter()')
  const fileStore = useFileStore()

  const { CofA, buildingCode } = getCofA(currentProject.value.province)
  console.log('cofA = ' + CofA)

  const payload = {
    customer: currentProject.value.customer.invoiceName,
    streetAddress: currentProject.value.streetAddress,
    city: currentProject.value.city,
    province: currentProject.value.province,
    CofA: CofA,
    email: userStore.currentEmail,
    name: userStore.currentUser,
    folderId: currentProject.value.folderId,
    filename: 'ENGINEERING REPORT - ' + currentProject.value.name,
    date: formatDate(new Date())
  }
  await fileStore.createGenericLetter(payload)
}

async function createBeamCalc() {
  console.log('project files.createBeamCalc()')
  const fileStore = useFileStore()
  await fileStore.createBeamCalc(currentProject.value)
}

async function downloadSchB(){
  console.log("files view downloadSchB...");
  const { downloadSchBPdf } = usePdfDownloader();
  const fields : schBForm = { 
    address : currentProject.value.streetAddress + ', ' + currentProject.value.city + ', ' + currentProject.value.province ,
    municipality : municipality.value,
    date : new Date().toISOString().split('T')[0] || new Date().toISOString()
  }
  const filename = currentProject.value.name + '-schB.pdf';
  await downloadSchBPdf(fields, filename);
}



</script>
